import React from 'react'

function Viewcalender() {


    return (
        <div className='App'>
            <div className='custom-calendy'>
                <div className='container'>
                    <div className="row align-items-center justify-content-center mt-5">
                        <div className="col-lg-10">
                            <div className="custom-calender-form-1">
                                <iframe
                                    className="custom-frame-1"
                                    src="https://calendly.com/info-5pa/30min?month=2023-11"
                                    title="Iframe Example"
                                    height="500" // pass as a string
                                    width="100%"
                                ></iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Viewcalender